<template>
    <div :class="['slider']">
        <div class="heading">
            <div class="block">
                <div class="pagination">
                    <div class="pagination-gabarit">
                        {{this.idx + 1 | undigit}} / {{this.count | undigit}}
                    </div>
                </div>
                <nav class="navigation">
                    <button @click="previous()" class="cta-container">
                        <IconArrow class="cta left" :color="'#000'"/>
                    </button>
                    <button @click="next()" class="cta-container">
                        <IconArrow class="cta right" :color="'#000'"/>
                    </button>
                </nav>
            </div>
        </div>
        <div class="content">
            <div class="block">
                <div class="main">
                    <div class="text" v-html="currentSlide.title"></div>
                </div>
                <div class="secondary" v-if="currentSlide.description">
                    <div class="text" v-html="currentSlide.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinSlidable from '@/components/MixinSlidable'
import IconArrow from "@/components/IconArrow"
export default {
    mixins: [MixinSlidable],
    components: {
        IconArrow
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        count() {
            return this.layout.layout.length
        },
        currentSlide() {
            return this.layout.layout[this.idx]
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.slider
    margin-bottom: 10%
    margin-top: 10%
    @media print
        margin-top: 1.2cm
        margin-bottom: 1.2cm
.heading
    border-bottom: 1px solid #e5e5e5
    @media print
        display: none
    .block
        height: 158px
        @include media-breakpoint-down($sm)
            height: 92px
.pagination
    flex: 1
    display: flex
    align-items: center
    .pagination-gabarit
        align-items: center
        padding-left: 18%
        font-size: 28px
        font-weight: 500
        color: #ff2b2a
        white-space: nowrap
        @include media-breakpoint-down($sm)
            font-size: 14px
.navigation
    flex: 1
    display: flex
    align-items: center
    justify-content: flex-end
    border-left: 1px solid #e5e5e5
.cta-container
    cursor: pointer
    opacity: 1
    transition: opacity .3s
    width: 32px
    height: 27px
    svg
        width: 100%
        height: 100%
    // &:hover
    //     opacity: 1
    &+.cta-container
        margin-left: 1.5em
.content
    .block
        @include media-breakpoint-down($hd)
            flex-direction: column
.block
    display: flex
        // width: 100%

.main
    flex: 1
    .text
        padding-right: 18%

.secondary
    flex: 1
    border-left: 1px solid #e5e5e5
    @include media-breakpoint-down($hd)
        border-left: none
        .text
            margin: 0
.text
    padding: 10% 0% 20% 18%
    @include media-breakpoint-down($hd)
        padding: 0
        margin: 9.6% 0 9.6% 0
    @media print
        margin-top: 0
        margin-bottom: 0
        padding-top: 0
        padding-bottom: 0
</style>
